import React from "react";
import "./App.css";
import MainComponent from "./MainComponent";

function App() {
  return (
    <div className="App">
      <MainComponent />
    </div>
  );
}

export default App;
